export const checkIfCheckPeriodIsLocked = (thisChecklistPeriod, thisChecklist, userData, loggedIn) => {
    let isLocked = false


    if (!thisChecklistPeriod || !thisChecklist || !userData || !loggedIn) {
        // console.error(`Missing required parameters: thisChecklistPeriod, thisChecklist, userData, or loggedIn`)
        return false
    }

    let isChecklistUserAccessShared = true
    if (
        thisChecklist['userAccess'] 
        && thisChecklist['userAccess']['type']
        && (thisChecklist['userAccess']['type'] === 'internalIndividual' || thisChecklist['userAccess']['type'] === 'externalIndividual')
    ) {
        isChecklistUserAccessShared = false
    }
    const startedByUserDetails = thisChecklistPeriod && thisChecklistPeriod['startedByUserDetails'] ? thisChecklistPeriod['startedByUserDetails'] : null


    // if the checklist does not allow concurrent users, and the period has been started by a user, then check if the logged in user is the same as the one who started the period
    if (isChecklistUserAccessShared === false && startedByUserDetails) {

        const checkPeriodUserLoginMethod = startedByUserDetails['loginMethod']
        const checkPeriodUserName = startedByUserDetails['name']
        const checkPeriodCognitoId = startedByUserDetails['cognitoUserId']

        if (checkPeriodUserLoginMethod === 'guest') {
            if (loggedIn !== 'guest') {
                // console.log(`🔐 locked because check period was started by a guest user but current user is not a guest`)
                return true
            }
            if (checkPeriodUserName !== userData['name']) {
                // console.log(`🔐 locked because check period was started by guest user '${checkPeriodUserName}' but current user is '${userData['name']}'`)
                return true
            }
        }
        if (checkPeriodCognitoId !== userData['cognito:username']) {
            // console.log(`🔐 locked because check period was started by user with cognito ID '${checkPeriodCognitoId}' but current user has cognito ID '${userData['cognitoUserId']}'`)
            return true
        }

    } else {
        // console.log(`🔐 unlocked because checklist allows concurrent users or check period was not started by a user`)
    }

    return isLocked
}